"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Formats the given label with the passed parameters.
 * Be careful with the order of the passed array, since the placeholders will be replaced in the order of the array.
 * E.g. <"This is a {0} text with {1}", ["sample", "parameters"]> will return "This is a sample text with parameters".
 * @param {string} label
 * @param values
 * @returns {string}
 */
function formatLabel(label) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    // console.log(label);
    var formattedLabel = label || '';
    if (label) {
        var count_1 = 0;
        values.forEach(function (val) {
            // console.log(val);
            formattedLabel = formattedLabel.replace('{' + count_1 + '}', val);
            count_1++;
        });
    }
    return formattedLabel;
}
exports.formatLabel = formatLabel;
exports.default = {
    formatLabel: formatLabel,
};
